import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// import Util from '@/utils/index';
// const MComponent = () => import("@/views/m/index.vue");
// const PCComponent = () => import("@/views/pc/index.vue");

const routes = [
  {
    path: "/",
    component: () => import("@/views/index.vue"),
    meta: {
      name: '首页'
    }
  },
  {
    path: "/global-afk-2407/",
    component: () => import("@/views/index.vue"),
    meta: {
      name: '首页'
    }
  },
];

// HTML5 history 模式
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
